import React, { useEffect, useState } from 'react';
import { getLayoutContest, getAllCoCreationContests, getContestCategories, getContestSearchPageNumber, getSearchResultContestFiltered } from '../../store/Selectors';
import { getMobileMode } from '../../store/DesallSelectors';
import DslStore, { setLayoutContest, setContestPageNumber, fetchCoCreationContest, setCategories } from '../../store/DslStore';
import { useStoreState } from 'pullstate';
import { PaginationSwitch } from '../../components/Contest/ContestsNavigation/ContestsNavigation';
import { Contest } from '../../global';
import { NoContent } from '../../components/Reusable/NoContent';
import ContestSearchNavigation from '../../components/SearchNavigation/ContestSearchNavigation';
import ContestCardWLF from '../../components/Contest/ContestCard/ContestCardWLF';
import ContestRowWLF from '../../components/Contest/ContestRow/ContestRowWLF';
import PopUpRedirectContest from '../../components/PopUp/PopUpRedirectContest/PopUpRedirectContest';
import DesallStore from '../../store/DesallStore';

const ContestSearch: React.FC = () => {
  const cocreationcontests = useStoreState(DslStore, getAllCoCreationContests);
  const contestCategories = useStoreState(DslStore, getContestCategories);
  const allContests = useStoreState(DslStore, getSearchResultContestFiltered);
  const mobileMode = useStoreState(DesallStore, getMobileMode);
  const layoutContest = useStoreState(DslStore, getLayoutContest);
  const pageNumber = useStoreState(DslStore, getContestSearchPageNumber);
  const [popup, setPopup] = useState(false);
  const [popupLink, setPopupLink] = useState('');
  const [linkToDescription, setLinkToDescription] = useState('');

  const [visibleContests, setVisibleContests] = useState<Contest[]>([]);

  const arraysfill = () => {
    let chunkSize = 20;
    let startchunk = (pageNumber - 1) * chunkSize;
    let tempArray: Contest[] = [];
    const chunk: Contest[] = allContests.slice(startchunk, startchunk + chunkSize);

    for (let i = 0; i < chunkSize; i++) {
      if (chunk[i] !== undefined) {
        tempArray.push(chunk[i]);
      } else {
        break;
      }
    }
    setVisibleContests(tempArray);
  };

  useEffect(() => {
    console.log('sono dentro contest');
    console.log(allContests);
    // fetchContestMini.run().then((data) => {
    //   console.log(data);
    // });
    // fillContests((pageNumber -1));

    arraysfill();
  }, []);

  useEffect(() => {
    arraysfill();
  }, [allContests]);

  useEffect(() => {
    // console.log(pageNumber);
    setVisibleContests(allContests);
    // fillContests(pageNumber -1);
    arraysfill();
  }, [pageNumber]);

  const handleExternalLink = (url: string, popupText: string) => {
    setPopupLink(url);
    setLinkToDescription(popupText);
    setPopup(true);
  };

  useEffect(() => {
    if (cocreationcontests.length === 0) {
      fetchCoCreationContest.run();
    }

    if (contestCategories) setCategories.run();
  }, []);

  //FIXME FIXME FIXME CONTEST LIKED

  return (
    <div className="bg-light-gray">
      <main className="container px-sm-5 px-lg-0  mb-5">
        <div className="row ">
          <div className="col-12 px-xl-4 px-lg-3 mb-3 ">
            <ContestSearchNavigation onChangeLayout={setLayoutContest} />
          </div>
        </div>

        <PopUpRedirectContest popup={popup} description={linkToDescription} close={() => setPopup(false)} link={popupLink} />

        <div className="row  px-lg-1 ">
          {layoutContest === 1
            ? visibleContests?.map((aContest: Contest, index: number) => <ContestCardWLF wrap={true} key={index} contest={aContest} clickHandler={handleExternalLink} />)
            : null}
        </div>
        <div className="row mt-4   px-lg-4">
          {layoutContest === 2
            ? visibleContests?.map((aContest: Contest, index: number) => <ContestRowWLF key={index} contest={aContest} clickHandler={handleExternalLink} />)
            : null}
        </div>
        <div className="row mt-4 px-3 ">{visibleContests.length === 0 && <NoContent />}</div>

        <div className="row ">
          <div className="col-12 px-4 d-flex justify-content-sm-start justify-content-md-end ">
            <PaginationSwitch onChangePage={setContestPageNumber} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default ContestSearch;
